import { createRollbar } from '@sunrun/sales-experience-shared';
import { firestoreRollbarTransform } from 'lib/firestore-errors';

const rollbar = createRollbar(
  'd23b47c35a4a4e64b1e247cf204e687a765eed3ea1a7d8f129fd61f4233d7f0124d1bf2188dec61f0aa98a235c498503',
  'UI',
  {
    transform: (payload) => {
      firestoreRollbarTransform(payload);
    },
  },
);

export { rollbar };
